import { Box, Grid, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ImageComponent from 'src/components/common/Image';
import { TARIFFS_AND_RULE_DEFAULT_PAGE_IMAGES } from 'src/utils/constants/imagesUrl';

const listItem = [
  {
    iconURL: TARIFFS_AND_RULE_DEFAULT_PAGE_IMAGES.avoid_costly_penalties,
    title: 'tariffs_and_rules.default_page.list.title1',
    description: 'tariffs_and_rules.default_page.list.description1',
  },
  {
    iconURL: TARIFFS_AND_RULE_DEFAULT_PAGE_IMAGES.optimize_market_entry,
    title: 'tariffs_and_rules.default_page.list.title2',
    description: 'tariffs_and_rules.default_page.list.description2',
  },
  {
    iconURL: TARIFFS_AND_RULE_DEFAULT_PAGE_IMAGES.enhance_supply_chain_efficiency,
    title: 'tariffs_and_rules.default_page.list.title3',
    description: 'tariffs_and_rules.default_page.list.description3',
  },
];

const PageDefault = () => {
  const { t } = useTranslation();
  return (
    <Box pt={2}>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={6}>
          <Stack height={'100%'} justifyContent={'space-between'}>
            <Box>
              <Typography mb={1} variant="h5">
                {t('tariffs_and_rules.default_page.title1')}
              </Typography>
              <Typography variant="body1" color={'text.secondary'}>
                {t('tariffs_and_rules.default_page.description1')}
              </Typography>
            </Box>
            <Typography variant="h5">{t('tariffs_and_rules.default_page.title2')}</Typography>
          </Stack>
        </Grid>

        <Grid item xs={12} lg={6}>
          <ImageComponent imgSrc={TARIFFS_AND_RULE_DEFAULT_PAGE_IMAGES.shipping_blue_box} width="100%" height="auto" />
        </Grid>

        <Grid item xs={12}>
          <Grid spacing={6} container>
            {listItem.map(({ iconURL, title, description }, index) => (
              <Grid key={`${index}-tariffs-title`} item lg={4} xs={12}>
                <ImageComponent imgSrc={iconURL} width={120} height="auto" />
                <Typography mt={2} mb={1} variant="h6">
                  {t(title)}
                </Typography>
                <Typography variant="body1" color={'text.secondary'}>
                  {t(description)}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PageDefault;
